import { PricingTypes } from "pages/purchase-plans/constants/defaultValues"
import usePricingVariables from "pages/purchase-plans/hooks/usePricingVariables"
import PricingVariables from "../pricing-variables/PricingVariables"
import PricingVariableTabs from "../pricing-variables/tabs/PricingVariableTabs"
import { useAppDispatch, useAppSelector } from "reducers/store"
import { IDevModePricingVariables } from "pages/purchase-plans/hooks/usePurchasePlan"

import { memo, useEffect } from "react"
import { resetPricingVariables } from "reducers/purchasePlan/purchase-plan-actions"

interface DevModePricingVariablesProps {
  isDevMode: boolean
  setDevModePricingVariablesToSubmition: (
    pricingVariables: IDevModePricingVariables,
    type: "expression" | "calculator"
  ) => void
}

const DevModePricingVariables = (props: DevModePricingVariablesProps) => {
  const { isDevMode, setDevModePricingVariablesToSubmition } = props

  const { pricingVariables } = useAppSelector((state) => state.purchasePlan.purchasePlanInfo.data)

  const {
    props: expressionProps,
    isValid: isExpressionValid,
    resetData: resetPricingExpression
  } = usePricingVariables(PricingTypes.EXPRESSION, {
    mathExp: pricingVariables.pricingExpression?.strExpression ?? "",
    list: pricingVariables.pricingExpression?.scope ?? []
  })

  const {
    props: calculatorProps,
    isValid: isCalculatorValid,
    resetData: resetPricingCalculator
  } = usePricingVariables(PricingTypes.CALCULATOR, {
    mathExp: pricingVariables.pricingCalculator?.strExpression ?? "",
    list: pricingVariables.pricingCalculator?.scope ?? []
  })

  const { productId } = useAppSelector((state) => state.purchasePlan.identifiers)

  useEffect(() => {
    if (!isDevMode) return

    setDevModePricingVariablesToSubmition(
      {
        list: calculatorProps.list,
        mathExp: calculatorProps.mathExpression,
        isValid: isCalculatorValid
      },
      "calculator"
    )
  }, [calculatorProps.list, calculatorProps.mathExpression, isCalculatorValid, isDevMode])

  useEffect(() => {
    if (!isDevMode) return

    setDevModePricingVariablesToSubmition(
      {
        list: expressionProps.list,
        mathExp: expressionProps.mathExpression,
        isValid: isExpressionValid
      },
      "expression"
    )
  }, [expressionProps.list, expressionProps.mathExpression, isExpressionValid, isDevMode])

  const appDispatch = useAppDispatch()

  useEffect(() => {
    return () => {
      resetPricingExpression()
      resetPricingCalculator()
      appDispatch(resetPricingVariables())
    }
  }, [])

  return (
    <>
      {isDevMode && !!productId && (
        <>
          <PricingVariableTabs
            pricingExpression={
              <PricingVariables
                {...expressionProps}
                label="Expressão da cobrança *"
                pricingType={PricingTypes.EXPRESSION}
              />
            }
            pricingCalculator={
              <PricingVariables
                {...calculatorProps}
                label="Expressão da visualização *"
                pricingType={PricingTypes.CALCULATOR}
              />
            }
          />
        </>
      )}
    </>
  )
}

export default memo(DevModePricingVariables)
